var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 14,
    viewBox: "0 0 43 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2386 4.45773C22.214 6.40019 23.9624 7.4841 25.2795 8.1286C26.6326 8.78981 27.0871 9.21386 27.0818 9.80523C27.0717 10.7102 26.0024 11.1096 25.0018 11.1251C23.2561 11.1523 22.2411 10.6518 21.4342 10.2733L20.8053 13.2283C21.6149 13.6029 23.114 13.9297 24.6686 13.944C28.3177 13.944 30.705 12.1351 30.718 9.33058C30.7322 5.7712 25.8153 5.57419 25.8489 3.98325C25.8605 3.50084 26.3189 2.98605 27.3233 2.85516C27.8205 2.78904 29.193 2.73843 30.749 3.458L31.3598 0.598964C30.5229 0.292988 29.4474 0 28.1084 0C24.6738 0 22.258 1.83349 22.2386 4.45773ZM37.2283 0.246264C36.5619 0.246264 36.0004 0.636578 35.7498 1.23554L30.5372 13.734H34.1837L34.9093 11.7202H39.3652L39.7861 13.734H43L40.1954 0.246264H37.2283ZM37.7384 3.88981L38.7907 8.9546H35.9087L37.7384 3.88981ZM17.8175 0.246433L14.9432 13.7338H18.4179L21.2909 0.246096H17.8175V0.246433ZM12.6771 0.246096L9.0604 9.42655L7.59739 1.6208C7.42573 0.749421 6.74781 0.246264 5.99497 0.246264H0.0828086L0 0.637927C1.21374 0.902409 2.59277 1.32899 3.42824 1.78542C3.93954 2.06424 4.08534 2.30798 4.2533 2.97053L7.02429 13.734H10.6962L16.3259 0.246264H12.6771",
    fill: "url(#paint0_linear_402_1073)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_1073",
    x1: 19.7688,
    y1: 14.2237,
    x2: 20.1741,
    y2: -0.0968799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.2941d077835a759b78df7912567fe00d.svg";
export { ForwardRef as ReactComponent };